export default __webpack_public_path__ + "static/media/jira.94adbaad.svg";